import { createEntitySelect } from './helpers/createEntitySelect';

import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';

export const deductionTypesQueryAtom = createQueryAtomFactory(
  'shared.selectDeductionType',
  () => ({
    deductionTypes: {
      __args: {
        pagination: {
          limit: 1000,
          offset: 0,
        },
      },
      entries: {
        id: true,
        name: true,
        applicationType: true,
      },
    },
  }),
  {
    select: (data) => data.deductionTypes.entries,
  },
);

export const SelectDeductionType = createEntitySelect(
  'SelectDeductionType',
  deductionTypesQueryAtom,
  {
    formatLabel: (entity) => entity.name,
  },
);
